import React from 'react';
import { stats } from '../mockData';

const Stats = () => {
  return (
    <section className="py-20 bg-[#F0F0F0]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
            Indikator SBE Trading Summary
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {stats.map((stat, index) => (
            <div 
              key={stat.id}
              className="bg-white rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-all hover:-translate-y-2 border-2 border-transparent hover:border-[#ED1C24]"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="text-5xl font-bold text-[#ED1C24] mb-3">
                {stat.value}
              </div>
              <div className="text-gray-700 font-medium mb-2">
                {stat.label}
              </div>
              {stat.subtitle && (
                <div className="text-sm text-gray-500">
                  {stat.subtitle}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;